import { createStyles } from "@mantine/emotion";

export const useStylesLanding = createStyles((theme) => ({
  landingContainer: {
    display: "block",
    position: "relative",
    padding: "1.333em 1.333em 0.8em 1.333em",
    width: "calc(100% - 2.666em)",
    marginLeft: "auto",
    marginRight: "auto",
    maxWidth: "76.533em",
    [`@media (max-width: 42.6em)`]: {
      padding: "0.667em 0.667em 0.4em 0.667em",
      width: "calc(100% - 1.334em)",
    },
  },

  // Guaranteed section start
  guaranteed: {
    textAlign: "center",
    paddingTop: "4.2em",
    [`@media (max-width: 67.33em)`]: {
      paddingTop: "0.87em",
    },
  },
  guaranteedTitle: {
    fontSize: "1.73em",
    lineHeight: "2em",
    fontFamily: theme.headings.fontFamily.bold,
    [`@media (max-width: 42.6em)`]: {
      fontSize: "1.53em",
    },
  },

  guaranteedText: {
    maxWidth: "47em",
    fontFamily: theme.headings.fontFamily.light,
    fontSize: "1.2em",
    lineHeight: "1.4em",
    marginLeft: "auto",
    marginRight: "auto",
    marginBottom: "3.33em",
  },

  guaranteedBlocks: {
    paddingTop: "2.5em",
    [`@media (max-width: 66.07em)`]: {
      paddingTop: "0.67em",
    },
  },

  guaranteedBlocksItem: {
    marginBottom: "6.67em",
    [`@media (max-width: 66.07em)`]: {
      display: "flex",
      flexWrap: "wrap",
      marginBottom: "3.33em",
    },
  },

  guaranteedBlocksItemTexts: {
    maxWidth: "28.67em",
    paddingRight: "1.33em",
    textAlign: "left",
    color: "#000",

    [`@media (max-width: 66.07em)`]: {
      maxWidth: "100%",
      paddingRight: 0,
      order: "-1",
    },
  },
  guaranteedBlocksItemTextsTitle: {
    fontFamily: theme.headings.fontFamily.secondary,
    fontSize: "2.4em",
    lineHeight: "1.17em",
    maxWidth: "10.84em",

    [`@media (max-width: 66.07em)`]: {
      maxWidth: "100%",
    },
  },

  guaranteedBlocksItemTextsText: {
    fontSize: "1.2em",
    lineHeight: "1.45em",
    fontFamily: theme.headings.fontFamily.light,
    marginTop: "1.7em",

    [`@media (max-width: 66.07em)`]: {
      paddingBottom: "1.5em",
    },
    b: {
      fontFamily: theme.headings.fontFamily.bold,
    },
  },
  guaranteedBlocksItemTextsTextB: {
    fontFamily: theme.fontFamily,
    fontWeight: "normal",
  },

  guaranteedBlocksItemSecureImg: {
    width: "10.2em",
    marginTop: "4em",
  },

  guaranteedBlocksItemContent: {
    minWidth: "36.13em",
    maxWidth: "42.4em",
    backgroundColor: "#F7F7F7",
    overflow: "hidden",
    position: "relative",
    width: "100%",
    minHeight: "26.47em",
    paddingTop: "5.53em",
    paddingLeft: "4.67em",
    paddingRight: "4.53em",
    paddingBottom: "2em",

    [`@media (max-width: 66.07em)`]: {
      maxWidth: "100%",
    },

    [`@media (max-width: 42.6em)`]: {
      minWidth: "auto",
      paddingTop: "2.67em",
      paddingLeft: "2.33em",
      paddingRight: "2.33em",
    },

    ".border-top, .border-bottom": {
      backgroundColor: "rgba(112,112,112,0.2)",
      width: "100%",
      height: "0.067em",
      position: "absolute",
      top: 0,
      left: 0,
    },

    ".border-bottom": {
      top: "auto",
      bottom: 0,
    },

    ".border-left, .border-right": {
      backgroundColor: "rgba(112,112,112,0.2)",
      width: "0.067em",
      height: "100%",
      position: "absolute",
      top: 0,
      left: 0,
    },

    ".border-right": {
      left: "auto",
      right: 0,
    },

    ".scalloped-top, .scalloped-bottom": {
      position: "absolute",
      background:
        "radial-gradient(ellipse at center, #fff 42%, rgba(112,112,112,0.2) 50%, transparent 0%)",
      backgroundSize: "2.39em 2em",
      backgroundRepeat: "repeat-x",
      width: "100%",
      height: "2.07em",
      left: "0.8em",
      maxWidth: "calc(100% - 1.47em)",
    },

    ".scalloped-top": { top: "-1.07em" },
    ".scalloped-bottom": { bottom: "-1.07em" },

    ".scalloped-left, .scalloped-right": {
      position: "absolute",
      background:
        "radial-gradient(ellipse at center, #fff 42%, rgba(112,112,112,0.2) 50%, transparent 0%)",
      backgroundSize: "2em 2.1em",
      backgroundRepeat: "repeat-y",
      width: "2.07em",
      height: "100%",
      top: "0.8em",
      maxHeight: "calc(100% - 1.07em)",
    },

    ".scalloped-left": { left: "-1.07em" },
    ".scalloped-right": { right: "-1.07em" },
  },
  guaranteedBlocksItemContentTextRight: {
    padding: "2.33em",
  },

  guaranteedBlocksTextRightItemTexts: {
    paddingRight: 0,
    paddingLeft: "1.33em",
    [`@media (max-width: 66.07em)`]: {
      paddingLeft: 0,
      order: -1,
    },
  },

  guaranteedBlocksTextRightItemTextsContent: {
    padding: "2.33em",
  },

  guaranteedFingerprintTop: {
    [`@media (max-width: 42.6em)`]: {
      display: "block",
    },
  },
  guaranteedFingerprintTopBrowse: {
    position: "relative",

    [`@media (min-width: 74.67em)`]: {
      marginLeft: "-2.67em",
    },

    [`@media (max-width: 42.6em)`]: {
      maxWidth: "10.73em",
      marginLeft: "auto",
      marginRight: "auto",
    },

    span: {
      position: "absolute",
      color: theme.customColors.white,
      fontSize: "0.87em",
      lineHeight: "1.07em",
      left: "4.05em",
      top: "1.45em",
      fontFamily: theme.headings.fontFamily.bold,
    },
  },
  guaranteedFingerprintTopBrowseImg: {
    width: "auto",
  },

  guaranteedFingerprintTopArrow: {
    marginLeft: "1.07em",
    marginRight: "1.07em",
    marginTop: "0.67em",
    width: "auto",

    [`@media (max-width: 42.6em)`]: {
      marginTop: "3.67em",
      transform: "rotate(90deg)",
      marginBottom: "3.67em",
      display: "block",
      marginLeft: "auto",
      marginRight: "auto",
      top: "-3.8em",
      position: "relative",
    },
  },
  guaranteedFingerprintTopArrowWrap: {
    [`@media (max-width: 42.6em)`]: {
      overflow: "hidden",
      maxHeight: "6em",
      marginTop: "0.67em",
    },
  },

  guaranteedFingerprintTopFingerprint: {
    width: "auto",
    [`@media (max-width: 42.6em)`]: {
      left: "-1.33em",
      marginLeft: "auto",
      marginRight: "auto",
      position: "relative",
    },
  },

  guaranteedFingerprintBottom: {
    marginTop: "2.4em",
    [`@media (max-width: 42.6em)`]: {
      display: "block",
    },
  },

  guaranteedFingerprintBottomItem: {
    maxWidth: "14.53em",
    color: "#000",

    [`@media (max-width: 42.6em)`]: {
      marginBottom: "1.33em",
      marginLeft: "auto",
      marginRight: "auto",
    },

    span: {
      marginBottom: "1em",
      display: "block",
      fontFamily: theme.headings.fontFamily.bold,
      fontSize: "0.93em",
      lineHeight: "1.13em",
    },

    p: {
      fontFamily: theme.headings.fontFamily.light,
      fontSize: "0.93em",
      lineHeight: "1.25em",
    },
  },

  guaranteedStamp: {
    backgroundColor: "#fff",
    paddingTop: "0.93em",
    paddingBottom: "2.73em",
    paddingLeft: "2.53em",
    paddingRight: "2.53em",
    gap: "5em",
    [`@media (max-width: 42.6em)`]: {
      padding: 0,
      background: "none",
    },
  },
  guaranteedStampFlexBlock: {
    [`@media (max-width: 42.6em)`]: {
      flexWrap: "wrap",
      gap: "1em",
    },
  },
  guaranteedStampTitle: {
    fontFamily: theme.headings.fontFamily.secondary,
    fontSize: "3.07em",
    lineHeight: "1.2em",
    marginBottom: "1em",
    marginTop: "0",
    textAlign: "center",
    fontWeight: "normal",
    [`@media (min-width: 42.67em)`]: {
      fontSize: "3.07",
      marginBottom: "0.2em",
    },
    [`@media (max-width: 42.6em)`]: {
      fontSize: "1.8em",
    },
  },
  guaranteedStampUserNameKey: {
    color: theme.customColors.blackLight,
    fontFamily: theme.headings.fontFamily.light,
    fontSize: "1.1em",
    lineHeight: "1.4em",
    paddingBottom: "0.5em",
  },
  guaranteedStampUserNameValue: {
    wordWrap: "break-word",
    color: theme.customColors.black,
    fontFamily: theme.headings.fontFamily.medium,
    fontSize: "1.47em",
    lineHeight: "1.5em",

    maxWidth: "100%",
  },
  guaranteedStampVerifiedIdentityKey: {
    color: theme.customColors.blackLight,
    fontFamily: theme.headings.fontFamily.light,
    fontSize: "1.1em",
    lineHeight: "1.4em",
    paddingBottom: "0.5em",
  },
  guaranteedStampVerifiedIdentityValue: {
    fontFamily: theme.headings.fontFamily.medium,
    fontSize: "1.47em",
    lineHeight: "1.3em",
  },
  guaranteedStampVerifiedIdentityValueImg: {
    height: "1em",
    marginRight: "0.3em",
    width: "1em",
    display: "inline-block",
  },
  guaranteedStampTimestampKey: {
    color: theme.customColors.blackLight,
    fontFamily: theme.headings.fontFamily.light,
    fontSize: "1.1em",
    lineHeight: "1.4em",
  },
  guaranteedStampTimestampValue: {
    fontSize: "1em",
    position: "relative",
  },
  guaranteedStampTimestampAgo: {
    backgroundColor: theme.customBackgrounds.timeDelta,
    borderRadius: "0.53em",
    display: "inline-block",
    fontSize: "0.95em",
    marginTop: "0.67em",
    padding: "0.4em 0.67em 0.33em",
  },
  guaranteedStampResultImg: {
    marginTop: "1.87em",
    width: "4.27em",
    height: "4.27em",
    marginLeft: "auto",
    marginRight: "auto",
    marginBottom: "0.87em",
  },
  // Guaranteed section end

  // Verifiable section start
  landingThree: {
    backgroundColor: theme.customBackgrounds.infoBlock,
    paddingTop: "5.2em",
    paddingBottom: "6.67em",
    [`@media (max-width: 66.07em)`]: {
      paddingTop: "2.67em",
      paddingBottom: "3.33em",
    },
  },
  landingThreeTitle: {
    fontSize: "2.4em",
    lineHeight: "1.3em",
    fontFamily: theme.headings.fontFamily.secondary,
    maxWidth: "23.5em",
    marginLeft: "auto",
    marginRight: "auto",
    marginBottom: "1.27em",
    textAlign: "center",
  },
  landingThreeText: {
    fontSize: "1.2em",
    lineHeight: "1.5em",
    fontFamily: theme.headings.fontFamily.light,
    maxWidth: "47em",
    marginLeft: "auto",
    marginRight: "auto",
    marginBottom: "2.1em",
    textAlign: "center",
  },
  landingThreeBlocks: {
    [`@media (max-width: 42.6em)`]: {
      display: "block",
    },
  },
  landingThreeBlocksItem: {
    backgroundColor: theme.customBackgrounds.white,
    paddingTop: "3.33em",
    paddingLeft: "1.87em",
    paddingRight: "1.6em",
    paddingBottom: "6.67em",
    width: "calc(33.33333% - 1.47em)",
    [`@media (max-width: 66.07em)`]: {
      paddingBottom: "3.33em",
    },
    [`@media (max-width: 42.6em)`]: {
      width: "100%",
      marginBottom: "2em",
    },
  },

  landingThreeBlocksItemContent: {
    height: "100%",
    img: {
      marginBottom: "1.1em",
      width: "2.66em",
    },
    span: {
      display: "block",
      fontSize: "1.33em",
      lineHeight: "1.6em",
      fontFamily: theme.headings.fontFamily.bold,
      color: theme.customColors.black,
      marginBottom: "0.9em",
    },

    p: {
      color: theme.customColors.black,
      fontSize: "1.07em",
      lineHeight: "1.4em",
      fontFamily: theme.headings.fontFamily.primary,
    },
  },

  supplementaryInformationTitle: {
    maxWidth: "100%",
    marginBottom: "0.97em",
    textAlign: "left",
  },
  supplementaryInformationBlocksItem: {
    paddingBottom: "2.5em",
    paddingLeft: "1.67em",
    paddingRight: "1.47em",
  },
  supplementaryInformationBlockButtons: {
    marginTop: "auto !important",
  },
  supplementaryInformationButton: {
    fontSize: "1.07em !important",
    marginTop: "1.81em",
    svg: {
      width: "1em",
      marginLeft: "0.3em",
    },
  },
  // Verifiable section end

  //Customer reviews start
  customerReviews: {
    paddingTop: "4.67em",
    paddingBottom: "4.27em",
    borderBottom: theme.customColors.borderReview,
    [`@media (max-width: 42.6em)`]: {
      paddingTop: "1.33em",
      paddingBottom: "1.33em",
    },
  },
  customerReviewsTitle: {
    fontSize: "2.4em",
    lineHeight: "1.5em",
    fontFamily: theme.headings.fontFamily.secondary,
    color: theme.customColors.black,
    marginBottom: "2.2em",
    [`@media (max-width: 42.6em)`]: {
      marginBottom: "0.5em",
      lineHeight: "1.2em",
    },
  },

  customerReviewsBlocks: {
    marginTop: "5.47em",
    paddingBottom: "1.33em",
    [`@media (max-width: 42.6em)`]: {
      marginTop: "1.33em",
    },
  },
  customerReviewsBlocksItem: {
    flex: "0 0 auto",
    width: "100%",

    p: {
      fontSize: "1.47em",
      lineHeight: "1.5em",
      fontFamily: theme.headings.fontFamily.light,
      marginTop: "0",
      marginBottom: "0.8em",
      color: theme.customColors.black,
      [`@media (max-width: 42.6em)`]: {
        fontSize: "1.07em",
        lineHeight: "1.73em",
      },
    },
  },
  customerReviewsBlocksItemAuthor: {
    paddingTop: "1.27em",
    img: {
      borderRadius: "50%",
      marginRight: "0.8em",
    },
  },
  customerReviewsBlocksItemAuthorName: {
    color: theme.customColors.reviewAuthor,
    lineHeight: "1.3em",
    fontFamily: theme.headings.fontFamily.bold,
    fontSize: "1.07em",
    span: {
      display: "block",
      fontFamily: theme.headings.fontFamily.light,
      fontSize: "0.93em",
      lineHeight: "1.6em",
      color: theme.customColors.blackLight,
      paddingTop: "0.3em",
    },
  },
  customerReviewsBlocksWrap: {
    ".mantine-Carousel-viewport": {
      maxWidth: "calc(76.9% - 2.67em)",
      marginLeft: "auto",
      marginRight: "auto",
      overflow: "hidden",
      [`@media (max-width: 42.6em)`]: {
        maxWidth: "calc(100% - 7em)",
      },
    },
    ".mantine-Carousel-control": {
      [`@media (max-width: 42.6em)`]: {
        width: "2em",
      },
      img: {
        cursor: "pointer",
        "&:hover": {
          opacity: "0.4",
        },
      },
    },

    ".mantine-Carousel-controls": {
      top: "16%",
      button: {
        [`@media (max-width: 42.6em)`]: {
          padding: "0",
        },
        "&:first-of-type": {
          marginLeft: "0.67em",
          marginRight: "0.4em",
          transform: "rotate(180deg)",
          [`@media (max-width: 42.6em)`]: {
            marginLeft: "0",
          },
        },
        "&:last-of-type": {
          marginRight: "0.67em",
          [`@media (max-width: 42.6em)`]: {
            marginRight: "0",
          },
        },
      },
    },
  },

  //Customer reviews end

  //Pricing start
  pricing: {
    paddingTop: "4.07em",
    paddingBottom: "5.87em",
    [`@media (max-width: 66.07em)`]: {
      paddingBottom: "2.93em",
      paddingTop: "2em",
    },
  },
  pricingTitle: {
    textAlign: "center",
    paddingBottom: "0.42em",
    fontSize: "2.40em",
    lineHeight: "1.2em",
    fontFamily: theme.headings.fontFamily.secondary,
  },

  pricingText: {
    textAlign: "center",
    fontSize: "1.33em",
    lineHeight: "1.2em",
    fontFamily: theme.headings.fontFamily.light,
    paddingBottom: "3em",
    color: theme.customColors.pricingText,
  },

  pricingDiy: {
    paddingTop: "0.62em",
    paddingBottom: "0.66em",
    paddingLeft: "0.83em",
    paddingRight: "0.88em",
    border: theme.customColors.diyBorder,
    fontFamily: theme.headings.fontFamily.light,
    fontSize: "1.4em",
    textAlign: "center",
    marginBottom: "1.25em",
    backgroundColor: theme.customBackgrounds.diy,

    img: {
      width: "1.333em",
      height: "1.333em",
      paddingRight: "0.48em",
      objectFit: "contain",
    },
    span: {
      fontFamily: theme.headings.fontFamily.bold,
      paddingRight: "0.67em",
      fontSize: "1em",
    },
    p: {
      margin: "0",
      paddingRight: "0.67em",
      fontFamily: theme.headings.fontFamily.light,
      fontSize: "1em",
    },
    a: {
      textDecoration: "underline",
      color: theme.customColors.diyText,
      fontFamily: theme.headings.fontFamily.light,
      fontSize: "1em",
      "&:hover": {
        textDecoration: "none",
      },
    },
  },

  pricingBlock: {
    [`@media (max-width: 66.07em)`]: {
      justifyContent: "center",
    },
    [`@media (max-width: 42.6em)`]: {
      display: "block",
    },
  },

  pricingBlockItem: {
    flexDirection: "column",
    width: "calc(33.33333% - 1.33em)",
    paddingLeft: "2.53em",
    paddingRight: "2.87em",
    paddingTop: "2.2em",
    paddingBottom: "3.8em",
    [`@media (max-width: 66.07em)`]: {
      width: "calc(50% - 1.2em)",
    },
    [`@media (max-width: 42.6em)`]: {
      marginLeft: "auto",
      marginRight: "auto !important",
      width: "100%",
      maxWidth: "24.4em",
      padding: "2em",
    },
  },

  pricingBlockItemFirst: {
    border: theme.customColors.pricingFirstBorder,
    [`@media (max-width: 66.07em)`]: {
      marginTop: "2.07em",
    },
  },

  pricingBlockItemSecond: {
    backgroundColor: theme.customBackgrounds.pricingSecond,
    color: theme.customColors.white,
    [`@media (max-width: 66.07em)`]: {
      marginTop: "2.07em",
    },
  },
  pricingBlockItemSecondButton: {
    "&:hover": {
      backgroundColor: theme.customBackgrounds.greenLight,
      color: theme.customColors.black,
    },
  },

  pricingBlockItemThird: {
    backgroundColor: theme.customBackgrounds.greenLight,
    [`@media (max-width: 66.07em)`]: {
      flexBasis: "calc(33.33333% + 3.33em)",
      marginTop: "2.07em",
      marginLeft: "auto",
      marginRight: "auto",
    },
    svg: {
      fill: theme.customBackgrounds.pricingSecond + " !important",
    },
  },

  pricingBlockItemHead: {
    marginBottom: "1.27em",
    minHeight: "4.27em",
    [`@media (max-width: 42.6em)`]: {
      marginBottom: "0.33em",
    },
  },
  pricingBlockItemHeadCustom: {
    display: "block",
    minHeight: "auto !important",
  },
  pricingBlockItemHeadTitle: {
    fontFamily: theme.headings.fontFamily.bold,
    fontSize: "2em",
    lineHeight: "1.2em",
    textTransform: "uppercase",
  },
  pricingBlockItemHeadTitleCustom: {
    fontSize: "2em",
    fontFamily: theme.headings.fontFamily.bold,
  },

  pricingBlockItemHeadSubtitle: {
    fontFamily: theme.headings.fontFamily.light,
    lineHeight: "1.3em",
    fontSize: "1.07em",
    paddingTop: "0.27em",
  },

  // Custom smaller subtitle for special plan mode
  pricingBlockItemHeadSubtitleCustom: {
    fontSize: "1.1em",
    fontFamily: theme.headings.fontFamily.light,
    lineHeight: "1.6em",
    paddingTop: "0.3em",
  },

  pricingBlockItemBody: {
    borderTop: theme.customColors.pricingFirstBorder,
    paddingTop: "2.20em",
    [`@media (max-width: 42.6em)`]: {
      paddingTop: "0.67em",
    },
  },

  pricingBlockItemBodyItem: {
    paddingBottom: "1.33em",

    svg: {
      marginRight: "0.87em",
      position: "relative",
      top: "0.33em",
      fill: theme.customBackgrounds.pricingBodySvg,
      height: "0.67em",
    },
  },

  pricingBlockItemBodyItemText: {
    lineHeight: "1.47em",
    span: {
      display: "block",
    },
  },
  pricingBlockItemBodyItemTextCustom: {
    fontFamily: theme.headings.fontFamily.bold,
  },

  pricingBlockItemFooter: {
    marginTop: "auto",
    svg: {
      fill: theme.customBackgrounds.greenLight,
      marginTop: "0.33em",
      top: "0.33em",
      position: "relative",
      path: {
        stroke: theme.customBackgrounds.pricingSecond,
      },
    },
  },
  pricingBlockButtons: {
    marginTop: "3.33em",
    [`@media (max-width: 42.6em)`]: {
      marginTop: "1.33em",
    },
  },
  pricingBlockButtonsButton: {
    borderRadius: "0.22em",
    lineHeight: "1.11em",
    padding: "0.67em 2.33em 0.56em 2.33em",
    textDecoration: "none",
    fontSize: "1.20em",
  },
  pricingBlockButtonsButtonWhite: {
    backgroundColor: theme.customBackgrounds.white,
    border: theme.customColors.borderButton,
    color: theme.customColors.black,
    display: "flex",
    alignItems: "center",
    "&:hover": {
      backgroundColor: theme.customBackgrounds.blackPrimary,
      color: theme.customColors.white,
    },
  },

  pricingBlockButtonsButtonDark: {
    backgroundColor: theme.customBackgrounds.blackPrimary,
    border: theme.customColors.borderButton,
    color: theme.customColors.white,
    display: "flex",
    alignItems: "center",
    "&:hover": {
      backgroundColor: theme.customBackgrounds.white,
      color: theme.customColors.buttonDarkHover,
    },
  },

  //Pricing end

  //Transform data security start
  transformDataSecurity: {
    paddingTop: "4.4em",
    paddingBottom: "4.67em",
    [`@media (max-width: 66.07em)`]: {
      paddingTop: "2.2em",
      paddingBottom: "2.33em",
    },
  },

  transformDataSecurityBlocks: {
    backgroundColor: theme.customBackgrounds.transformDataSecurity,
    border: "1px solid " + theme.customColors.greenLight,
    borderRadius: "0.13em",
    [`@media (max-width: 42.6em)`]: {
      display: "block",
    },
  },

  transformDataSecurityBlocksTexts: {
    paddingLeft: "5.87em",
    paddingTop: "2.53em",
    paddingRight: "1.33em",
    paddingBottom: "3.13em",
    maxWidth: "40.2em",
    [`@media (max-width: 42.6em)`]: {
      paddingLeft: "1.33em",
    },
    span: {
      display: "block",
      fontSize: "2.4em",
      lineHeight: "1.17em",
      fontFamily: theme.headings.fontFamily.bold,
      marginBottom: "0.58em",
      color: theme.customColors.black,
    },
    p: {
      fontSize: "1.33em",
      lineHeight: "1.2em",
      fontFamily: theme.headings.fontFamily.light,
      marginBottom: "0.3em",
      color: theme.customColors.black,
    },
  },
  transformDataSecurityBlocksTextsImg: {
    minWidth: "18.67em",
  },

  learnMore: {
    position: "absolute",
    bottom: "3.33em",
    left: "calc(50% - 2.33em)",
    cursor: "pointer",
    [`@media (max-width: 42.6em)`]: {
      bottom: "1.33em",
    },
    span: {
      color: theme.customColors.blackLight,
      fontSize: "0.93em",
      lineHeight: "1.21em",
      display: "block",
    },

    img: {
      display: "block",
      marginLeft: "auto",
      marginRight: "auto",
      marginTop: "0.5em",
      width: "1.36em",
    },
  },

  //Transform data security end
}));
